import { useState, useEffect } from "react";
import confetti from "canvas-confetti";
import { useSound } from 'react-sounds';
import yaySound from './yay.mp3'
import { v4 as uuidv4 } from "uuid";

function rand(min, max) {
  return Math.random() * (max - min) + min;
}

function areSetsEqual(n, m) {
  if (n.size !== m.size) return false;
  for (let item of n) {
    if (!m.has(item)) return false;
  }
  return true;
}

function Square({letter, onSelect, onDeselect}) {
  const [isOn, setIsOn] = useState(false);

  function doAction() {
    if (isOn) {
      onDeselect();
    } else {
      onSelect();
    }
    setIsOn(!isOn)
  }
  return(
    <div className="square">
      <button className={`square-btn ${isOn ? 'square-btn-on' : 'square-btn-off'}`}
			onClick={doAction}>{letter}</button>
    </div>
  );
}

function Grid({grid, answers}) {
  const [selectedSquares, setSelectedSquares] = useState(new Set());
  const [isCompleted, setCompleted] = useState(false);
  const { play } = useSound(yaySound);

  function onSelect(square) {
    const coords = square[0] + "," + square[1];
    selectedSquares.add(coords);
    if (areSetsEqual(selectedSquares, answers)) {
      celebrate();
    }
    setSelectedSquares(selectedSquares);
  }

  function onDeselect(square) {
    const coords = square[0] + "," + square[1];
    selectedSquares.delete(coords);
    if (areSetsEqual(selectedSquares, answers)) {
      celebrate();
    }
    setSelectedSquares(selectedSquares);
  }

  function celebrate() {
    confetti({
      angle: rand(55, 125),
      spread: rand(50, 70),
      particleCount: rand(50, 100),
      origin: { y: 0.6 }
    });
    play();
  }

  if (grid.length === 0) {
    return (
      <div></div>
    );
  }

  const rows = grid.map((row, y) => (
    <div className="row">
      {row.map((l, x) => (
	<Square key={uuidv4()} letter={l}
		onSelect={() => onSelect([y, x])}
		onDeselect={() => onDeselect([y, x])}/>
      ))}
    </div>
  ));

  return (
    <div className={`${rows.length > 12 ? 'large' : 'small'}`}>
      <div className="grid">
	{rows}
      </div>
    </div>
   );
}

function Col({items}) {
  const list = items.map(i =>
    <Word key={uuidv4()} text={i}/>
  );

  return (
    <div className="col">{list}</div>
  );
}

function Word({text}) {
  const [isOn, setIsOn] = useState(false);

  if (isOn) {
    return(
      <div><button className="word-li word-li-on" onClick={() => setIsOn(!isOn)}>{text}</button></div>
    )
  } else {
    return(
      <div><button className="word-li word-li-off" onClick={() => setIsOn(!isOn)}>{text}</button></div>
    )
  }
}

function PrintButton() {
  return(
    <div className="print-btn noprint">
      <button onClick={() => window.print()}>Print this Find-A-Word</button>
    </div>
  );
}

function Words({words}) {
  if (words.length === 0) {
    return (
      <div className="words"></div>
    );
  }

  const size = Math.floor(words.length / 3);
  if (size === 0) {
    return (
      <>
	<div className="words">
	  <div className="col-container">
	    <Col items={words}/>
          </div>
        </div>
        <PrintButton/>
      </>
    );
  }

  const cols = intoGroups(words.slice(), 3).map(col =>
    <Col items={col}/>
  );

  return(
    <>
      <div className="words">
        <div className="col-container">
	  {cols}
        </div>
      </div>
      <PrintButton/>
    </>
  );
}

function toArr(words) {
  return words.trim().split(/[ \n]+/).map(w => w.trim());
}

function intoGroups(arr, n) {
  const perGroup = Math.ceil(arr.length / n);
  return new Array(n)
    .fill('')
    .map((_, i) => arr.slice(i * perGroup, (i + 1) * perGroup));
}

function PostWords({input, onUpdate}) {
  return(
    <textarea cols="24"
	      rows="8"
	      value={input}
	      onChange={e => {onUpdate(e.target.value)}}/>
  );
}

function SizeSelection({size, onUpdate}) {
  return (
    <div className="size-panel">
      <input type="radio"
	     name="size"
	     value="small"
	     id="small"
	     checked={size === 12}
	     onChange={e => {onUpdate(e.target.value)}}/>
      <label htmlFor="small">Small</label>
      <input type="radio"
	     name="size"
	     value="large"
	     id="large"
	     checked={size === 20}
	     onChange={e => {onUpdate(e.target.value)}}/>
      <label htmlFor="large">Large</label>
    </div>
  );
}

function fetchData(words, size, onFetch) {
  fetch("https://xn4603s104.execute-api.ap-southeast-2.amazonaws.com/prod/create", {
    method: "POST",
    body: JSON.stringify({
      "words": words,
      "height": size,
      "width": size
    }),
    headers: {"Content-Type": "application/json; charset=UTF-8"}
  })
    .then(response => response.json())
    .then(data => {
      onFetch(data, size);
    });
}

function noFetch(onFetch) {
  onFetch({"grid": [["e","n","i","m","c","j","t","j","j","g","m","a"],["k","w","r","m","t","e","r","r","x","b","e","u"],["n","x","h","f","w","s","m","h","r","y","b","n"],["i","f","j","q","r","v","o","d","s","n","g","g"],["g","b","u","c","j","o","g","m","y","i","n","m"],["h","s","e","p","f","k","o","f","x","i","a","n"],["t","b","c","k","c","q","n","k","k","b","e","s"],["r","m","b","i","s","h","o","p","x","e","p","r"],["p","l","z","n","u","b","t","j","u","a","h","u"],["n","b","w","i","w","h","w","q","n","u","c","h"],["a","a","d","b","v","j","v","k","t","j","v","t"],["p","c","e","v","l","j","g","o","r","f","d","s"]], "words": ["rook","knight","king","bishop","pawn","queen"], "answers": [[1, 2], [4, 5]]}, 12);
}

function CreateButton({words, size, onFetch}) {
  return (
    <div>
      <button onClick={() => fetchData(toArr(words), size, (data, size) => { onFetch(data, size, false) })}>
	Create
      </button>
    </div>
  );
}

export default function WordFinder() {
  const [data, setData] = useState({
    grid: [],
    words: [],
    answers: new Set(),
    wordsInput: "",
    size: 20,
    isDefault: true
  });

  const [navOpen, setNavOpen] = useState(false);
  function toggleNav() {
    setNavOpen(!navOpen);
  };

  function onFetch(data, size, isDefault) {
    setData({
      grid: data.grid,
      words: data.words,
      answers: parseAnswers(data.answers),
      wordsInput: "",
      size: size,
      isDefault: isDefault
    });
  }

  function parseAnswers(answers) {
    const coords = new Set();
    for (let i = 0; i < answers.length; i++) {
      const coord = answers[i][0] + "," + answers[i][1]
      coords.add(coord)
    }
    return coords
  }

  function updateSize(size) {
    if (size === "small") {
      setData({
	...data,
	size: 12
      });
    } else if (size === "large") {
      setData({
	...data,
	size: 20
      });
    } else {
      throw new Error("unknown size: " + size)
    }
  }

  function create(words, size) {
    fetchData(words, size, (data, size) => { onFetch(data, size, false) });
  }

  useEffect(() => {
    fetchData(["mercury","venus","earth","mars","jupiter","saturn","uranus","neptune"],
	      12,
    	      (data, size) => { onFetch(data, size, true) });
    //noFetch((data, size) => { onFetch(data, size, true) });
  }, []);

  return (
    <>
      <button className="hamburger" onClick={() => toggleNav()}>
        <span></span>
        <span></span>
        <span></span>
      </button>
      <div className="main-panel">
	<div className="print-panel">
	  <h1>Find-A-Word</h1>
          {data.isDefault ? (
	    <div className="welcome noprint">
              <p>Heya! Here you can make and print a Find-A-Word activity sheet.
	      You can also just make and solve the puzzles right here on your device.</p>
	      <p>Can you solve this one I made for you?</p>
	      <p>(⊃｡•́‿•̀｡)⊃━☆ﾟ.*･｡ﾟ</p>
	    </div>
	  ) : (
	    <div></div>
	  )}
          {data.grid === undefined ? (
	    <div><p>One sec, fetching some data...</p></div>
	  ) : (
	    <div>
	      <Grid grid={data.grid} answers={data.answers}/>
	      <Words words={data.words}/>
	    </div>
	  )}
        </div>
      </div>
      <div className={`create-panel no-print ${navOpen ? 'open' : ''}`}>
        <div>Create a new Find-A-Word, type the words you'd like to include:</div>
        <PostWords input={data.wordsInput}
		   onUpdate={words => {
		     setData({
		       ...data,
		       wordsInput: words
		     });
		   }}/>
	<SizeSelection size={data.size} onUpdate={updateSize}/>
        <CreateButton words={data.wordsInput} size={data.size} onFetch={onFetch}/>
	<div>
	  <p>Here are some ideas, click them to generate a Find-A-Word:</p>
	  <div className="create-action">
	    <div className="create-action"><span className="clickable" onClick={() => create(["fox", "owl", "sheep", "horse", "lion", "elephant", "tiger", "bear", "giraffe", "gazelle", "monkey", "panda", "penguin", "seal", "whale", "shark"], 12)}>Animals</span></div>
	    <div className="create-action"><span className="clickable" onClick={() => create(["andesite","bauxite","chalk","claystone","diorite","flint","granite","limestone","marble","obsidian","pumice","quartz","sandstone","shale","slate"], 12)}>Rocks</span></div>
	    <div className="create-action"><span className="clickable" onClick={() => create(["hufflepuff", "ravenclaw", "slytherin", "gryffindor", "hogwarts", "siriusblack", "voldemort", "chochang", "dumbledore", "muggle", "hermione", "ronweasley", "harrypotter", "darco"], 20)}>Harry Potter</span></div>
	    <div className="create-action"><span className="clickable" onClick={() => create(["spiderman", "ironman", "starlord", "blackpanther", "captainmarvel", "captainamerica", "blackwidow", "hawkeye", "nickfury", "gamora", "thor", "hulk", "thanos", "doctorstrange", "antman", "drax", "groot", "wolverine"], 20)}>Marvel</span></div>
	    <div className="create-action"><span className="clickable" onClick={() => create(["barnacles","kwazii","peso","inkling","shellington","tweak","dashi","tunip","calicojack","paani","pearl","natquik","marsh","koshi","pinto"], 12)}>Octonauts</span></div>
	    <div className="create-action"><span className="clickable" onClick={() => create(["always","away","bird","dog","fast","four","going","hand","keep","let","many","night","people","round","take","thing","tree","water","work"], 12)}>Sight Words - Aqua</span></div>
	    <div className="create-action"><span className="clickable" onClick={() => create(["call","come","here","make","must","only","some","then","were","what","will","your"], 12)}>Sight Words - Indigo</span></div>
	    <div className="create-action"><span className="clickable" onClick={() => create(["any","because","blue","every","fell","gave","green","house","last","long","morning","open","red","sat","soon","than","time","very","why","year"], 12)}>Sight Words - Lemon</span></div>
	    <div className="create-action"><span className="clickable" onClick={() => create(["another","bad","black","dont","father","found","got","head","know","live","may","once","put","run","should","tell","three","under","white","would"], 12)}>Sight Words - Lime</span></div>
	    <div className="create-action"><span className="clickable" onClick={() => create(["back","been","came","down","from","just","like","made","much","over","them","this","well","went","when"], 12)}>Sight Words - Orange</span></div>
	    <div className="create-action"><span className="clickable" onClick={() => create(["after","am","boy","day","eat","five","fly","girl","good","help","home","jump","play","ran","read","saw","sing","sit","think","us"], 12)}>Sight Words - Pink</span></div>
	    <div className="create-action"><span className="clickable" onClick={() => create(["again","ask","best","bring","far","find","give","how","kind","left","man","mother","own","room","say","step","these","too","walk","wish"], 12)}>Sight Words - Purple</span></div>
	    <div className="create-action"><span className="clickable" onClick={() => create(["about","before","could","first","little","look","more","other","right","their","there","want","where","which"], 12)}>Sight Words - Violet</span></div>

	  </div>
	</div>
      </div>
    </>
  );
}
